var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{'is-active': _vm.isActive}, 'ColorFilter--' + _vm.color, 'ColorFilter'],on:{"click":_vm.toggleColor}},[_c('IconBase',{attrs:{"iconName":"check","iconColor":"#000"}},[_c('IconCheck')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }